import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtomValue } from 'jotai'
import { ROUTES } from 'app/config/routes'
import { currentUserAtom } from 'store'
import { permission } from 'utils/permission'
import { ApplyPanels } from './components/ApplyPanels'
import { FileUploader } from './components/FileUploader'
import { Dataset } from './constants/dataset'
import { UPLOAD_JOB_ID_KEY } from './constants/storage'

export function PharmacyDataUpdate() {
  const navigate = useNavigate()
  const currentUser = useAtomValue(currentUserAtom)

  const [lastUploadedInfo, setLastUploadedInfo] = useState<{
    name: string
    dataset: Dataset
    uploadToken?: string
  } | null>(null)
  const [updateInfo, setUpdateInfo] = useState<{
    name?: string
    dataset: Dataset
    jobId: string
  } | null>(null)

  const onUploadedHandler = (
    name: string,
    dataset: Dataset,
    uploadToken: string,
  ) => {
    setUpdateInfo(null)
    setLastUploadedInfo({ name, dataset, uploadToken })
  }

  const onComplete = () => {
    sessionStorage.removeItem(UPLOAD_JOB_ID_KEY)
    setUpdateInfo(null)
    setLastUploadedInfo(null)
  }

  useEffect(() => {
    if (!currentUser || !permission.canAccessPharmacyDataUpdate(currentUser)) {
      navigate(ROUTES.HOME, { replace: true })
    }
  }, [currentUser, navigate])

  useEffect(() => {
    const raw = sessionStorage.getItem(UPLOAD_JOB_ID_KEY)
    if (!raw) {
      return
    }
    try {
      const data = JSON.parse(raw) as Partial<{
        jobId: string
        dataset: Dataset
        name?: string
      }>
      if (typeof data.jobId === 'string' && typeof data.dataset === 'string') {
        setLastUploadedInfo({ name: data.name || '', dataset: data.dataset })
        setUpdateInfo({
          name: data.name,
          dataset: data.dataset,
          jobId: data.jobId,
        })
      } else {
        sessionStorage.removeItem(UPLOAD_JOB_ID_KEY)
      }
    } catch {
      sessionStorage.removeItem(UPLOAD_JOB_ID_KEY)
    }
  }, [])

  return (
    <div className="flex flex-col gap-4 max-w-[512px]">
      <div className="flex flex-col gap-4 items-center border border-gray-300 rounded-lg p-4 w-full">
        {updateInfo ? (
          <div className="flex flex-col items-center">
            <p>データを反映しています...</p>
          </div>
        ) : (
          <FileUploader setUploadedInfo={onUploadedHandler} />
        )}
      </div>
      <ApplyPanels
        uploadedInfo={lastUploadedInfo}
        updateInfo={updateInfo}
        jobId={updateInfo?.jobId || undefined}
        setUpdateInfo={setUpdateInfo}
        onComplete={onComplete}
      />
    </div>
  )
}
